export default __webpack_public_path__ + "1787e18644.svg";